/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, {useCallback, useEffect, useState, useRef} from 'react';
import MapBase from "./MapBase";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
//import {arrayToRgb, formatUid, getApiUrl, makeTableSorterFn, numberWithCommas, positionToDegress} from "../../utils";
//import WidgetContainer from "./widgets/WidgetContainer";
import WidgetContainer2 from "./widgets/WidgetContainer2"; // 확장된 위젯
import WidgetContainer3 from "./widgets/WidgetContainer3";
import WidgetFrq2 from "./widgets/WidgetFrq2";
import WidgetCls1 from "./widgets/WidgetCls1";
import RMateChartJointTableTown from "./r_mate_chart/RMateChartJointTableTown";
import {PALETTE_YlOrRd_9, TRANSPARENT_COLOR} from "../../utils/Palette";
import {WELL_KNOWN_POSITION} from "../../Constants";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetTable from "./widgets/WidgetTable";
import AlignRightText from "./widgets/AlignRightText";
import WidgetUidWithShortcut from "./widgets/WidgetUidWithShortcut";
import Seperator from "./widgets/Seperator";
import WidgetSelectBand from "./widgets/WidgetSelectBand";

import {arrayToRgb, formatUid, getApiUrl, makeTableSorterFn, numberWithCommas, positionToDegress, getApiHost} from "../../utils";
import Axios from "axios";











//// 대한민국 지도 위경도 최저점 124.6097088, 128.9711903, 33.11371207, 37.42829748
  //// '지역코드': ['지역명', 면적, 최소X, 최대X, 최소Y, 최대Y]
  const SIDO_AREA = {
    '99': ['전국', 100401, 124.6097088, 128.9711903, 33.11371207, 37.42829748],
    '11': ['서울특별시', 605.2370016, 126.764484, 127.1837949, 37.42829748, 37.70145528],
    '26': ['부산광역시', 770.0734132, 128.7617179, 129.3056048, 34.88967614, 35.38903745],
    '27': ['대구광역시', 883.5173075, 128.3514757, 128.7626927, 35.6065399, 36.01616512],
    '28': ['인천광역시', 1063.257851, 124.6097088, 126.7936954, 36.9199482, 37.9842102],
    '29': ['광주광역시', 501.1362608, 126.6447028, 127.0222752, 35.05089543, 35.25870398],
    '30': ['대전광역시', 539.6265149, 127.2466527, 127.5596787, 36.18310006, 36.50023064],
    '31': ['울산광역시', 1062.038814, 128.9711903, 129.4638573, 35.3293263, 35.72491979],
    '36': ['세종특별자치시', 464.9496802, 127.1277299, 127.4108036, 36.4067584, 36.73382188],
    '41': ['경기도', 10192.51425, 126.3801016, 127.8481131, 36.89377502, 38.28226055],
    '42': ['강원도', 16828.28073, 127.0950376, 129.3637813, 37.02783249, 38.61370931],
    '43': ['충청북도', 7406.819936, 127.2756505, 128.6520965, 36.01220684, 37.25833428],
    '44': ['충청남도', 8245.54072, 125.540788, 127.6397483, 35.97826412, 37.06475374],
    '45': ['전라북도', 8069.13898, 125.9668466, 127.9113674, 35.2992326, 36.15657043],
    '46': ['전라남도', 12345.20948, 125.0777264, 127.9056266, 33.96857286, 35.48691383],
    '47': ['경상북도', 19033.34312, 127.7961521, 131.8727834, 35.56688816, 37.54999098],
    '48': ['경상남도', 10540.37356, 127.5760707, 129.219072, 34.5020077, 35.90994406],
    '50': ['제주특별자치도', 1850.227389, 126.1441158, 126.970428, 33.11371207, 34.01530323],
  
    '11110': ['종로구', 23.9132804, 126.9488986, 127.0233653, 37.56581995, 37.63237477],
    '11140': ['중구', 9.9599825, 126.9615497, 127.026797, 37.5438574, 37.57202235],
    '11170': ['용산구', 21.8663835, 126.9445852, 127.0175303, 37.50653164, 37.55566257],
    '11200': ['성동구', 16.8593427, 127.0081533, 127.0737353, 37.52832386, 37.57302083],
    '11215': ['광진구', 17.0629485, 127.0562191, 127.1152526, 37.5225151, 37.57376349],
    '11230': ['동대문구', 14.2153601, 127.0231387, 127.0782259, 37.5599626, 37.60762863],
    '11260': ['중랑구', 18.4960714, 127.0694236, 127.1184772, 37.56969397, 37.62105465],
    '11290': ['성북구', 24.5743486, 126.9746709, 127.0717322, 37.57751809, 37.63645689],
    '11305': ['강북구', 23.6001017, 126.9796581, 127.0497367, 37.60897372, 37.68508882],
    '11320': ['도봉구', 20.6609646, 127.0076208, 127.0558729, 37.63041427, 37.70145528],
    '11350': ['노원구', 35.4375379, 127.0416582, 127.1125489, 37.61426729, 37.69613747],
    '11380': ['은평구', 29.7114205, 126.8820309, 126.9633288, 37.57600492, 37.65921539],
    '11410': ['서대문구', 17.6256375, 126.9018291, 126.9694641, 37.55345105, 37.6106169],
    '11440': ['마포구', 23.8513431, 126.8536286, 126.9638983, 37.53378085, 37.59079264],
    '11470': ['양천구', 17.4057101, 126.8215906, 126.8906843, 37.50286943, 37.55124009],
    '11500': ['강서구', 41.4368534, 126.764484, 126.8807919, 37.52648417, 37.60503275],
    '11530': ['구로구', 20.1201063, 126.8130124, 126.9031986, 37.47318779, 37.51777521],
    '11545': ['금천구', 13.0202602, 126.8717626, 126.9285065, 37.43351779, 37.48666212],
    '11560': ['영등포구', 24.5485201, 126.8779286, 126.9498868, 37.48500155, 37.55626943],
    '11590': ['동작구', 16.3546176, 126.9031986, 126.9853851, 37.47537655, 37.51762099],
    '11620': ['관악구', 29.5689288, 126.8989438, 126.9886358, 37.43571232, 37.49507101],
    '11650': ['서초구', 46.9832847, 126.9798349, 127.095753, 37.42829748, 37.52559504],
    '11680': ['강남구', 39.5010127, 127.0085783, 127.1242069, 37.45611617, 37.53584131],
    '11710': ['송파구', 33.8727292, 127.0675012, 127.1614311, 37.46652088, 37.54317131],
    '11740': ['강동구', 24.5902555, 127.1091428, 127.1837949, 37.51683534, 37.58120072],
    '26110': ['중구', 2.825782, 129.021177, 129.0444432, 35.09567543, 35.1166045],
    '26140': ['서구', 13.9796123, 128.9960152, 129.0280967, 35.04797613, 35.14098869],
    '26170': ['동구', 9.8652354, 129.0243086, 129.0662186, 35.10866378, 35.14617372],
    '26200': ['영도구', 14.1995953, 129.030992, 129.1052425, 35.03669907, 35.10364837],
    '26230': ['부산진구', 29.6662376, 129.0105031, 129.0828319, 35.13550752, 35.20007885],
    '26260': ['동래구', 16.6317737, 129.0441288, 129.1163703, 35.18332587, 35.22627318],
    '26290': ['남구', 26.8181048, 129.0630011, 129.1287208, 35.09090755, 35.16131846],
    '26320': ['북구', 39.3700905, 128.986963, 129.0617673, 35.18747514, 35.27689461],
    '26350': ['해운대구', 51.474858, 129.1102401, 129.2084106, 35.15184622, 35.25096791],
    '26380': ['사하구', 41.769978, 128.9339779, 129.0143649, 34.88967614, 35.13684517],
    '26410': ['금정구', 65.2740569, 129.0365643, 129.1446059, 35.20954078, 35.30658404],
    '26440': ['강서구', 181.4946451, 128.7617179, 128.9982243, 34.98909277, 35.23608051],
    '26470': ['연제구', 12.0989026, 129.0473211, 129.115177, 35.15817376, 35.19953439],
    '26500': ['수영구', 10.2124294, 129.0915523, 129.135035, 35.13575165, 35.18650038],
    '26530': ['사상구', 36.093426, 128.9574447, 129.021085, 35.1169248, 35.20145512],
    '26710': ['기장군', 218.2986856, 129.108562, 129.3041396, 35.18161986, 35.38903745],
    '27110': ['중구', 7.0551845, 128.573853, 128.6147671, 35.85493281, 35.8794787],
    '27140': ['동구', 182.1459818, 128.6033592, 128.7626927, 35.85116065, 36.01616512],
    '27170': ['서구', 17.3331245, 128.5163433, 128.5819141, 35.85448274, 35.8956501],
    '27200': ['남구', 17.4315319, 128.5553845, 128.6088841, 35.80734649, 35.86018404],
    '27230': ['북구', 93.9839076, 128.5041702, 128.632478, 35.87373415, 35.98798734],
    '27260': ['수성구', 76.5353448, 128.5916824, 128.7269187, 35.78987601, 35.87835996],
    '27290': ['달서구', 62.3397, 128.4686946, 128.5876185, 35.77292881, 35.86959529],
    '27710': ['달성군', 426.6925324, 128.3514757, 128.6954856, 35.6065399, 35.94314944],
    '28110': ['중구', 140.2868995, 126.355785, 126.6442014, 37.35690761, 37.54240541],
    '28140': ['동구', 7.1948307, 126.6099047, 126.6744309, 37.46838895, 37.49577305],
    '28170': ['남구', 24.83503, 126.6290108, 126.7029394, 37.42998946, 37.48403285],
    '28185': ['연수구', 54.9478658, 126.5830483, 126.7066551, 37.34180711, 37.43942568],
    '28200': ['남동구', 57.0166436, 126.667427, 126.7804322, 37.38250419, 37.47993673],
    '28237': ['부평구', 32.0087621, 126.6832485, 126.7677535, 37.46448211, 37.52408165],
    '28245': ['계양구', 45.5651801, 126.6810558, 126.7936954, 37.52345027, 37.59370282],
    '28260': ['서구', 117.0873904, 126.525579, 126.7256655, 37.47093479, 37.63948862],
    '28710': ['강화군', 411.411035, 125.9587449, 126.5439604, 37.58101805, 37.83219739],
    '28720': ['옹진군', 172.9042139, 124.6097088, 126.6950943, 36.9199482, 37.9842102],
    '29110': ['동구', 49.312364, 126.9071535, 127.004318, 35.07246799, 35.16548902],
    '29140': ['서구', 47.7481211, 126.8006304, 126.9097427, 35.09072075, 35.17860731],
    '29155': ['남구', 61.0182378, 126.7531364, 126.9296285, 35.05089543, 35.15249901],
    '29170': ['북구', 120.2804727, 126.8348555, 127.0222752, 35.12129064, 35.25846773],
    '29200': ['광산구', 222.7770652, 126.6447028, 126.8604091, 35.07017021, 35.25870398],
    '30110': ['동구', 136.6797553, 127.4136511, 127.5596787, 36.19474636, 36.44000809],
    '30140': ['중구', 62.1791849, 127.3675326, 127.4590584, 36.20712691, 36.34963133],
    '30170': ['서구', 95.5255209, 127.2790405, 127.4046108, 36.18310006, 36.37201523],
    '30200': ['유성구', 176.5290231, 127.2466527, 127.4202651, 36.26416339, 36.50023064],
    '30230': ['대덕구', 68.7130307, 127.3893013, 127.5044719, 36.34092703, 36.47720999],
    '31110': ['중구', 37.0105086, 129.2526177, 129.3536803, 35.54490305, 35.59911202],
    '31140': ['남구', 73.4665224, 129.2365395, 129.3889014, 35.45779099, 35.55691054],
    '31170': ['동구', 36.0746855, 129.3876642, 129.4582329, 35.47151815, 35.57154023],
    '31200': ['북구', 157.3570882, 129.289422, 129.4638573, 35.51600757, 35.67943953],
    '31710': ['울주군', 758.1300097, 128.9711903, 129.3682577, 35.3293263, 35.72491979],
    '41111': ['수원시 장안구', 33.3423169, 126.9603414, 127.0397739, 37.28519274, 37.3510449],
    '41113': ['수원시 권선구', 47.1703297, 126.926981, 127.0421714, 37.22454425, 37.30333878],
    '41115': ['수원시 팔달구', 12.8561093, 126.9773375, 127.0459654, 37.25652098, 37.29360949],
    '41117': ['수원시 영통구', 27.7234205, 127.0323906, 127.089632, 37.23127641, 37.32099545],
    '41131': ['성남시 수정구', 45.4556557, 127.0417656, 127.1769303, 37.39560508, 37.47579918],
    '41133': ['성남시 중원구', 26.4115622, 127.1169794, 127.1958191, 37.40518914, 37.47480927],
    '41135': ['성남시 분당구', 69.7658519, 127.0277048, 127.1772461, 37.3333749, 37.417319],
    '41150': ['의정부시', 81.5448323, 127.0016941, 127.1472566, 37.68581356, 37.78030393],
    '41171': ['안양시만안구', 36.5343815, 126.870242, 126.9489432, 37.35833175, 37.45021266],
    '41173': ['안양시동안구', 21.9329309, 126.9273576, 126.9828549, 37.36163545, 37.44078698],
    '41195': ['부천시 원미구', 20.611111, 126.7414708, 126.8225505, 37.48225531, 37.52233302],
    '41197': ['부천시 소사구', 12.81111, 126.7423104, 126.8336007, 37.45837562, 37.49070234],
    '41199': ['부천시 오정구', 20.11111, 126.7599886, 126.8288374, 37.50573866, 37.55424238],
    '41210': ['광명시', 38.5264277, 126.8261012, 126.8999259, 37.40152436, 37.4951283],
    '41220': ['평택시', 458.2441779, 126.7790107, 127.1545273, 36.90159564, 37.14467342],
    '41250': ['동두천시', 95.6643075, 127.0062206, 127.1553708, 37.86034122, 37.98104926],
    '41271': ['안산시상록구', 57.9898597, 126.8145082, 126.9396102, 37.26843875, 37.37746612],
    '41273': ['안산시단원구', 97.7410953, 126.3801016, 126.8431432, 37.08046953, 37.36590651],
    '41281': ['고양시덕양구', 165.5748871, 126.7595204, 126.9943576, 37.57179049, 37.74848501],
    '41285': ['고양시일산동구', 59.9526931, 126.7324601, 126.8560621, 37.62560948, 37.73704415],
    '41287': ['고양시일산서구', 42.5607502, 126.6703561, 126.781796, 37.64752148, 37.70728399],
    '41290': ['과천시', 35.8683192, 126.9609087, 127.0473692, 37.40059171, 37.46772039],
    '41310': ['구리시', 33.3250638, 127.1008879, 127.170598, 37.55633533, 37.64608112],
    '41360': ['남양주시', 458.1154703, 127.0802326, 127.3809862, 37.50549946, 37.78052759],
    '41370': ['오산시', 42.7077244, 126.994914, 127.1030928, 37.12532349, 37.20087289],
    '41390': ['시흥시', 138.6600456, 126.6853837, 126.8816444, 37.31459384, 37.47239323],
    '41410': ['군포시', 36.4168539, 126.8727643, 126.9628413, 37.30505436, 37.37867237],
    '41430': ['의왕시', 53.9876113, 126.9293116, 127.0471133, 37.30032137, 37.41561273],
    '41450': ['하남시', 92.9911862, 127.1393299, 127.2857013, 37.46877186, 37.59176888],
    '41461': ['용인시처인구', 467.5179298, 127.1087277, 127.4277541, 37.08363577, 37.36044196],
    '41463': ['용인시기흥구', 81.6436544, 127.0647247, 127.1771279, 37.21553251, 37.32472245],
    '41465': ['용인시수지구', 42.097662, 127.0164857, 127.1424445, 37.29323106, 37.37232035],
    '41480': ['파주시', 673.2291988, 126.659318, 127.0171071, 37.68860572, 38.01059074],
    '41500': ['이천시', 461.4218906, 127.3300311, 127.6377767, 37.04124688, 37.36170318],
    '41550': ['안성시', 553.418704, 127.102016, 127.5165915, 36.89377502, 37.15588907],
    '41570': ['김포시', 276.6120884, 126.5170499, 126.8025814, 37.57957047, 37.79009816],
    '41590': ['화성시', 697.766499, 126.5282688, 127.1613673, 37.01337608, 37.30326892],
    '41610': ['광주시', 430.9903471, 127.1325969, 127.4466381, 37.26501793, 37.53586453],
    '41630': ['양주시', 310.3902974, 126.9019544, 127.1221926, 37.66868534, 37.94211948],
    '41650': ['포천시', 826.9574931, 127.0897962, 127.4470759, 37.74692923, 38.18832123],
    '41670': ['여주시', 608.2983723, 127.3982194, 127.7684117, 37.1350555, 37.44042632],
    '41800': ['연천군', 676.3180656, 126.7857704, 127.1921559, 37.92821672, 38.28226055],
    '41820': ['가평군', 843.6905747, 127.266914, 127.6171412, 37.57114667, 38.05123017],
    '41830': ['양평군', 877.6513595, 127.3059227, 127.8481131, 37.36701285, 37.67079274],
    '42110': ['춘천시', 1116.3739, 127.5061481, 128.0296083, 37.67564492, 38.08502534],
    '42130': ['원주시', 868.2402378, 127.7441007, 128.2184553, 37.14340828, 37.50690993],
    '42150': ['강릉시', 1040.783864, 128.5803597, 129.0740462, 37.50329591, 37.91717291],
    '42170': ['동해시', 180.2019795, 128.9576185, 129.1607137, 37.42679759, 37.60453883],
    '42190': ['태백시', 303.5211881, 128.8671618, 129.0956603, 37.06168505, 37.34559284],
    '42210': ['속초시', 105.760448, 128.4211401, 128.6144545, 38.11895323, 38.23076455],
    '42230': ['삼척시', 1187.839038, 128.8459356, 129.3637813, 37.03866531, 37.47638364],
    '42720': ['홍천군', 1820.310463, 127.5352446, 128.5887955, 37.55226276, 37.94551994],
    '42730': ['횡성군', 998.0665559, 127.7594215, 128.3022667, 37.29880427, 37.68015987],
    '42750': ['영월군', 1127.289701, 128.1071624, 128.9104166, 37.02783249, 37.40896138],
    '42760': ['평창군', 1463.928054, 128.2435292, 128.7651107, 37.2666346, 37.82138508],
    '42770': ['정선군', 1219.777975, 128.5059738, 128.9896627, 37.14707732, 37.59291585],
    '42780': ['철원군', 889.6823105, 127.0950376, 127.8466407, 38.08976855, 38.34781545],
    '42790': ['화천군', 908.9318555, 127.430532, 127.9136383, 37.99428686, 38.28805709],
    '42800': ['양구군', 661.8191056, 127.8517454, 128.172391, 38.00162464, 38.33730594],
    '42810': ['인제군', 1644.967141, 127.9775123, 128.5135742, 37.81199581, 38.37896629],
    '42820': ['고성군', 660.707506, 128.2428922, 128.5849074, 38.18733135, 38.61370931],
    '42830': ['양양군', 630.0794025, 128.4042467, 128.8091882, 37.8620186, 38.16189088],
    '43111': ['청주시 상당구', 404.362103, 127.445264, 127.7697823, 36.40820615, 36.7299932],
    '43112': ['청주시 서원구', 122.6346396, 127.3720418, 127.4996248, 36.44919472, 36.6466245],
    '43113': ['청주시 흥덕구', 198.8045267, 127.2756505, 127.4818555, 36.56168453, 36.72491586],
    '43114': ['청주시 청원구', 215.0432543, 127.317993, 127.6189145, 36.64483599, 36.78026344],
    '43130': ['충주시', 983.4775549, 127.6508511, 128.1340441, 36.79663753, 37.21486086],
    '43150': ['제천시', 883.4221125, 127.9215833, 128.3333966, 36.81169523, 37.25833428],
    '43720': ['보은군', 584.2075304, 127.5145128, 127.9063363, 36.36897447, 36.61377392],
    '43730': ['옥천군', 537.2211751, 127.4860484, 127.8912712, 36.17070956, 36.44528865],
    '43740': ['영동군', 846.0161978, 127.5894371, 128.0581462, 36.01220684, 36.31663972],
    '43745': ['증평군', 81.7976484, 127.5373271, 127.6645999, 36.70128063, 36.86007512],
    '43750': ['진천군', 407.3033482, 127.2878289, 127.5851597, 36.74872555, 37.01211365],
    '43760': ['괴산군', 842.1890198, 127.6204583, 128.0727238, 36.60111832, 36.94755361],
    '43770': ['음성군', 520.1821657, 127.4453481, 127.7984813, 36.83383018, 37.15528659],
    '43800': ['단양군', 780.1586596, 128.2171249, 128.6520965, 36.80207603, 37.15820618],
    '44131': ['천안시동남구', 438.3867716, 127.0083639, 127.4204171, 36.61974955, 36.89219698],
    '44133': ['천안시서북구', 197.6959429, 127.0740824, 127.290588, 36.78492694, 36.97307408],
    '44150': ['공주시', 864.1527403, 126.8835727, 127.2822967, 36.27712061, 36.67924702],
    '44180': ['보령시', 586.5582767, 125.9554224, 126.7387151, 36.17186164, 36.52479137],
    '44200': ['아산시', 542.7957556, 126.8290936, 127.119714, 36.64861173, 36.94224122],
    '44210': ['서산시', 742.0266678, 126.3158752, 126.6536208, 36.60040188, 37.02653055],
    '44230': ['논산시', 555.5804132, 126.9836511, 127.3335688, 36.06303331, 36.34028508],
    '44250': ['계룡시', 60.6988548, 127.1963465, 127.291916, 36.23176054, 36.35024882],
    '44270': ['당진시', 705.4241092, 126.402599, 126.8590617, 36.74926208, 37.06475374],
    '44710': ['금산군', 577.2371293, 127.3180148, 127.6397483, 35.97826412, 36.27218865],
    '44760': ['부여군', 624.5346299, 126.6784523, 127.0703079, 36.07103233, 36.38704225],
    '44770': ['서천군', 366.1158064, 126.4686066, 126.8710853, 35.99097454, 36.19009061],
    '44790': ['청양군', 479.0999651, 126.6719297, 127.028246, 36.31449818, 36.57181191],
    '44800': ['홍성군', 446.698483, 126.4261905, 126.7731913, 36.45973377, 36.67302094],
    '44810': ['예산군', 542.6481845, 126.5853245, 126.9723436, 36.52666329, 36.80372137],
    '44825': ['태안군', 515.8869898, 125.540788, 126.4348902, 36.39581401, 36.97796886],
    '45111': ['전주시완산구', 92.5049676, 127.0504177, 127.21702, 35.72857399, 35.84331884],
    '45113': ['전주시덕진구', 113.5358734, 126.9978435, 127.2342894, 35.80165117, 35.90310751],
    '45130': ['군산시', 396.6834424, 125.9668467, 126.915402, 35.67035829, 36.12783331],
    '45140': ['익산시', 506.5370474, 126.8514075, 127.139722, 35.8834938, 36.15657043],
    '45180': ['정읍시', 693.0391207, 126.7155234, 127.1169369, 35.4610852, 35.75899114],
    '45190': ['남원시', 752.191724, 127.1839071, 127.6740693, 35.3024577, 35.56082085],
    '45210': ['김제시', 545.8642676, 126.6537155, 127.0866788, 35.66614313, 35.91771125],
    '45710': ['완주군', 821.0553089, 126.9951537, 127.3782289, 35.61888714, 36.13084089],
    '45720': ['진안군', 789.0917393, 127.2652974, 127.6248396, 35.61869617, 36.02949513],
    '45730': ['무주군', 631.7555253, 127.5243686, 127.9113674, 35.78823093, 36.06866713],
    '45740': ['장수군', 533.2021655, 127.3618119, 127.6998094, 35.46781389, 35.83894326],
    '45750': ['임실군', 597.222768, 127.0830936, 127.4360998, 35.45971051, 35.77767816],
    '45770': ['순창군', 495.7940668, 126.8597392, 127.3142699, 35.2992326, 35.55612685],
    '45790': ['고창군', 607.484716, 126.4267121, 126.7741755, 35.30078698, 35.57482209],
    '45800': ['부안군', 493.1762466, 126.1015758, 126.8411294, 35.55832888, 35.81286957],
    '46110': ['목포시', 51.620811, 126.2897083, 126.4594393, 34.74526248, 34.84440424],
    '46130': ['여수시', 512.0842716, 127.2193043, 127.9056265, 34.00480382, 34.89909692],
    '46150': ['순천시', 911.0550378, 127.1748434, 127.5936966, 34.82608957, 35.18911873],
    '46170': ['나주시', 608.403003, 126.5133096, 126.8992005, 34.86793834, 35.11485533],
    '46230': ['광양시', 463.0874705, 127.5255045, 127.7868231, 34.8865819, 35.1826946],
    '46710': ['담양군', 455.0916025, 126.8541996, 127.1179981, 35.11595447, 35.46657185],
    '46720': ['곡성군', 547.4670053, 127.0812325, 127.4122803, 35.0693624, 35.33694924],
    '46730': ['구례군', 443.2434066, 127.366887, 127.6246247, 35.09469317, 35.36533563],
    '46770': ['고흥군', 807.3722815, 127.0821966, 127.5456256, 34.31743139, 34.82774449],
    '46780': ['보성군', 664.0123415, 126.9718443, 127.480806, 34.63496583, 34.98752915],
    '46790': ['화순군', 787.0117125, 126.8238777, 127.2016335, 34.82369774, 35.21429401],
    '46800': ['장흥군', 622.3420738, 126.7929344, 127.0462106, 34.42198284, 34.87782693],
    '46810': ['강진군', 500.909508, 126.6564813, 126.8858486, 34.44657589, 34.78644238],
    '46820': ['해남군', 1031.306018, 126.2399037, 126.734864, 34.29291162, 34.76211484],
    '46830': ['영암군', 612.561438, 126.3625046, 126.8592898, 34.66508846, 34.94634458],
    '46840': ['무안군', 449.7110439, 126.2422433, 126.5569982, 34.76847214, 35.16680886],
    '46860': ['함평군', 392.1030123, 126.3703699, 126.6721191, 34.97350971, 35.23558223],
    '46870': ['영광군', 474.9630933, 125.9861213, 126.6447988, 35.16384189, 35.42998255],
    '46880': ['장성군', 518.4019011, 126.5833169, 126.9265277, 35.19071811, 35.48691383],
    '46890': ['완도군', 396.761181, 126.3804112, 127.2012404, 33.96857286, 34.46073813],
    '46900': ['진도군', 440.1000253, 125.8006371, 126.3853, 34.14071897, 34.59291399],
    '46910': ['신안군', 655.6012368, 125.0777266, 126.3788951, 34.04771083, 35.21270044],
    '47111': ['포항시 남구', 393.9056157, 129.2768159, 129.584684, 35.83833895, 36.08586208],
    '47113': ['포항시 북구', 736.1720798, 128.9894908, 129.4551864, 36.01415181, 36.33336524],
    '47130': ['경주시', 1324.857727, 128.9707268, 129.5202083, 35.64035589, 36.07969716],
    '47150': ['김천시', 1009.801474, 127.875271, 128.3012344, 35.82893402, 36.2583412],
    '47170': ['안동시', 1522.098729, 128.4284889, 129.0015984, 36.29572351, 36.82316259],
    '47190': ['구미시', 615.3467023, 128.1327799, 128.5640029, 36.06058117, 36.36246683],
    '47210': ['영주시', 670.0890676, 128.4239697, 128.7455693, 36.69537033, 37.06571436],
    '47230': ['영천시', 919.2051394, 128.6941594, 129.1513273, 35.83008981, 36.18459344],
    '47250': ['상주시', 1254.640829, 127.7961521, 128.3390371, 36.23716356, 36.65676725],
    '47280': ['문경시', 911.9025454, 127.8742929, 128.3720486, 36.51302319, 36.87232867],
    '47290': ['경산시', 411.7568669, 128.6813968, 128.9709485, 35.7005009, 35.99392289],
    '47720': ['군위군', 614.3247422, 128.4104391, 128.9001967, 36.00730678, 36.32723646],
    '47730': ['의성군', 1174.734216, 128.2876822, 128.8966208, 36.19071322, 36.53259155],
    '47750': ['청송군', 846.1206388, 128.8468883, 129.2542091, 36.16062654, 36.59496305],
    '47760': ['영양군', 815.7493464, 128.9837804, 129.3141162, 36.48892094, 36.88154702],
    '47770': ['영덕군', 741.2201626, 129.1477081, 129.4529043, 36.26655606, 36.67387162],
    '47820': ['청도군', 693.8103042, 128.5268084, 129.0469011, 35.56688816, 35.84594804],
    '47830': ['고령군', 384.0598016, 128.1593285, 128.483069, 35.61088094, 35.85240618],
    '47840': ['성주군', 616.1064446, 128.0466509, 128.3991348, 35.77719224, 36.05539539],
    '47850': ['칠곡군', 450.9370335, 128.2849571, 128.6407204, 35.88644812, 36.12589864],
    '47900': ['예천군', 661.4838873, 128.2606446, 128.6105205, 36.45435112, 36.84860646],
    '47920': ['봉화군', 1202.034345, 128.6375209, 129.185462, 36.74648815, 37.10040201],
    '47930': ['울진군', 990.0432237, 129.0771965, 129.4787046, 36.64353116, 37.14682969],
    '47940': ['울릉군', 72.9422026, 130.7914867, 131.8728622, 37.2378891, 37.55321888],
    '48121': ['창원시 의창구', 210.7740945, 128.5592924, 128.7641166, 35.21711119, 35.39337762],
    '48123': ['창원시 성산구', 82.5950509, 128.5892585, 128.7513938, 35.15091576, 35.24599742],
    '48125': ['창원시 마산합포구', 241.1578293, 128.3481364, 128.6398623, 35.05218094, 35.22250908],
    '48127': ['창원시 마산회원구', 90.5854353, 128.4736597, 128.6269372, 35.1770851, 35.27707716],
    '48129': ['창원시 진해구', 122.9202313, 128.6067162, 128.8432703, 35.05588424, 35.18117331],
    '48170': ['진주시', 712.8601976, 127.8878177, 128.3682004, 35.05092384, 35.35112805],
    '48220': ['통영시', 239.8604677, 128.1255874, 128.7360636, 34.53351026, 34.97637999],
    '48240': ['사천시', 398.6750934, 127.8789647, 128.1843523, 34.88694023, 35.15935056],
    '48250': ['김해시', 463.4478265, 128.6915789, 129.0148178, 35.15046486, 35.39554917],
    '48270': ['밀양시', 798.6712237, 128.5711667, 129.0246229, 35.34550695, 35.64061874],
    '48310': ['거제시', 403.2285795, 128.4552848, 128.7762147, 34.66965286, 35.04079855],
    '48330': ['양산시', 485.6043537, 128.8740728, 129.219072, 35.27375861, 35.53226753],
    '48720': ['의령군', 482.9108299, 128.0825795, 128.4374473, 35.25336632, 35.51738375],
    '48730': ['함안군', 416.6020108, 128.2740418, 128.5916502, 35.16401283, 35.40151346],
    '48740': ['창녕군', 532.8307074, 128.3504435, 128.6516393, 35.36856729, 35.68315511],
    '48820': ['고성군', 517.9571506, 128.1011804, 128.5014942, 34.87876172, 35.13243789],
    '48840': ['남해군', 357.5456589, 127.807011, 128.1133299, 34.5020077, 34.94697446],
    '48850': ['하동군', 675.2369819, 127.5760707, 127.9392539, 34.92401985, 35.33256272],
    '48860': ['산청군', 794.6045149, 127.6879114, 128.1151991, 35.21903105, 35.57621059],
    '48870': ['함양군', 725.4852135, 127.5848612, 127.8779238, 35.31575532, 35.77137366],
    '48880': ['거창군', 803.3129492, 127.6794363, 128.0951843, 35.5143957, 35.90994406],
    '48890': ['합천군', 983.5071593, 127.9532286, 128.3798552, 35.36790321, 35.83227408],
    '50110': ['제주시', 978.6689592, 126.1441158, 126.970428, 33.27296418, 34.01530323],
    '50130': ['서귀포시', 871.5584302, 126.1687502, 126.9454592, 33.11371207, 33.48308107],
    
  };



const ICON_MAPPING = {
  '32': ['cls1', '기지국'],
  '42': ['cls2', '의무선박국'],
  '21': ['cls3', '고정국'],
  '80': ['cls4', '일반지구국'],
  '72': ['cls5', '지구국'],
  '44': ['cls6', '육상무선국'],
  '41': ['cls7', '선박국'],
  '73': ['cls8', '선박지구국'],
  '76': ['cls9', '육상이동지구국'],
  '46': ['cls10', '의무항공기국'],
  '93': ['cls11', '실용화시험국(실험국용)'],
  '91': ['cls12', '실험국'],
  '71': ['cls13', '우주국'],
  '52': ['cls14', '무선표지국'],
  '75': ['cls15', '이동지구국'],
  '57': ['cls16', '무선탐지육상국'],
  '61': ['cls17', '비상국'],
  '92': ['cls18', '아마추어국'],
  '74': ['cls19', '해안지구국'],
  '55': ['cls20', '무선측위국'],
  '45': ['cls21', '항공기국'],
  '78': ['cls22', '항공기지구국'],
  '70': ['cls23', '육상지구국'],
  '49': ['cls24', '이동국'],
  '53': ['cls25', '무선항행육상국'],
  '54': ['cls26', '무선항행이동국'],
  '81': ['cls27', '산업용'],
  '99': ['cls28', '전파천문국'],
};

/*
const ICON_MAPPING = {
    '32': ['cls1', '기지국'],
    '85': ['cls2', '이동중계국'],
    '94': ['cls3', '간이무선국'],
    '44': ['cls4', '육상무선국'],
    '49': ['cls5', '이동국'],
    '92': ['cls6', '아마추어국'],
    '42': ['cls7', '의무선박국'],
    '41': ['cls8', '선박국'],
    '21': ['cls9', '고정국'],
    '35': ['cls10', '육상국'],
    '11': ['cls11', '지상파방송국'],
    '12': ['cls12', '실용화시험국(방송국용)'],
    '13': ['cls13', '위성방송국'],
    '15': ['cls14', '신고제외무선국'],
    '16': ['cls15', '지상파방송보조국'],
    '17': ['cls16', '발신전용휴대전화(CT-2)'],
    '18': ['cls17', '가입자회선용무선국'],
    '19': ['cls18', '위성방송보조국'],
    '22': ['cls19', '전송망'],
    '23': ['cls20', '종합유선방송국'],
    '24': ['cls21', '중계유선방송'],
    '25': ['cls22', '음악유선방송'],
    '27': ['cls23', '개인휴대전화(PCS)'],
    '28': ['cls24', '주파수공용무선전화(자가용)'],
    '29': ['cls25', '무선조정중계국'],
    '30': ['cls26', '무선조정이동국'],
    '31': ['cls27', '해안국'],
    '33': ['cls28', '항공국'],
    '34': ['cls29', '휴대기지국'],
    '36': ['cls30', '일반해안국'],
    '37': ['cls1', '무선데이타통신'],
    '38': ['cls2', '어업용해안국'],
    '40': ['cls3', '구명부기국'],
    '43': ['cls4', '비상위치지시용무선표지국'],
    '45': ['cls5', '항공기국'],
    '46': ['cls6', '의무항공기국'],
    '47': ['cls7', '휴대국'],
    '48': ['cls8', '선상통신국'],
    '50': ['cls9', '선박국대여'],
    '51': ['cls10', '무선방향탐지국'],
    '52': ['cls11', '무선표지국'],
    '53': ['cls12', '무선항행육상국'],
    '54': ['cls13', '무선항행이동국'],
    '55': ['cls14', '무선측위국'],
    '56': ['cls15', '무선항행국'],
    '57': ['cls16', '무선탐지육상국'],
    '58': ['cls17', '무선탐지이동국'],
    '59': ['cls18', '비상위치지시용위성무선표지국'],
    '61': ['cls19', '비상국'],
    '62': ['cls20', '표준주파수및시보국'],
    '63': ['cls21', '기상원조국'],
    '64': ['cls22', '구내무선국'],
    '65': ['cls23', '주파수공용간이무선국'],
    '66': ['cls24', '차량디지틀이동전화'],
    '67': ['cls25', '휴대디지틀이동전화'],
    '68': ['cls26', '차량/휴대디지틀이동전화'],
    '69': ['cls27', '위성휴대통신용무선국'],
    '70': ['cls28', '육상지구국'],
    '71': ['cls29', '우주국'],
    '72': ['cls30', '지구국'],
    '73': ['cls1', '선박지구국'],
    '74': ['cls2', '해안지구국'],
    '75': ['cls3', '이동지구국'],
    '76': ['cls4', '육상이동지구국'],
    '77': ['cls5', '항공지구국'],
    '78': ['cls6', '항공기지구국'],
    '79': ['cls7', '기지지구국'],
    '80': ['cls8', '일반지구국'],
    '81': ['cls9', '산업용'],
    '82': ['cls10', '통신용'],
    '83': ['cls11', '의료용'],
    '84': ['cls12', '차량이동가입무선전화'],
    '86': ['cls13', '휴대이동가입무선전화'],
    '87': ['cls14', '주파수공용무선전화'],
    '88': ['cls15', '생활무선국(CB)'],
    '89': ['cls16', '차량/휴대가입무선전화'],
    '90': ['cls17', '이동품질감시'],
    '91': ['cls18', '실험국'],
    '93': ['cls19', '실용화시험국(실험국용)'],
    '95': ['cls20', '고정수신국'],
    '96': ['cls21', '무선호출국'],
    '97': ['cls22', '무선조정국'],
    '98': ['cls23', '코드레스폰'],
    '99': ['cls24', '전파천문국'],
    // 'RD': ['cls25', '레이다펄스변조송신'],
    // 'TV': ['cls26', 'TV방송국'],
};
*/

let clsCoverageList =
[
  {
    "usgType": "common",
    "usgCode": 32,
    "usgNm": "기지국11111",
    "usgCoverage": 1,
    "usgArea": 0,
   },
  {
    "usgType": "common",
    "usgCode": 85,
    "usgNm": "이동중계국22222",
    "usgCoverage": 1,
    "usgArea": 0,
   },
   {
    "usgType": "common",
    "usgCode": 94,
    "usgNm": "간이무선국33333",
    "usgCoverage": 1,
    "usgArea": 0,
   },
   {
    "usgType": "common",
    "usgCode": 44,
    "usgNm": "육상무선국44444",
    "usgCoverage": 1,
    "usgArea": 0,
   },
   {
    "usgType": "common",
    "usgCode": 80,
    "usgNm": "이동국55555",
    "usgCoverage": 1,
    "usgArea": 0,
   },
];

let disCoverageList =
[
  {
      "usgType": "location",
      "usgCode": "11",
      "usgNm": "서울",
      "usgCoverage": 1,
      "usgArea": 1
  },
  {
      "usgType": "location",
      "usgCode": "42",
      "usgNm": "강원",
      "usgCoverage": 1,
      "usgArea": 1
  }
];

const FRQ_CODE_DICT = {
  '1': ['town-digital1', '주파수']
};

const ICON_CODE_BY_CLS_CODE = Object.entries(ICON_MAPPING).reduce((acc, [clsCode, [iconCode]]) => {
  acc[clsCode] = iconCode;
  return acc;
}, {});

const FRQ_CODE_OPTIONS = Object.entries(FRQ_CODE_DICT).map(([frqCode, [iconCode, iconLabel]]) => {
  return { frq_code: frqCode, label: iconLabel };
});

const CLS_CODE_OPTIONS = Object.entries(ICON_MAPPING).map(([clsCode, [iconCode, iconLabel]]) => {
  return { cls_code: clsCode, label: iconLabel };
});

const MapJointuseUtil = () => {
  const [fillColorLegend, setFillColorLegend] = useState();

  const mapProps = useMapProps({
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      currentDistrictCode: '',
    },
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (object, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {properties: {pk, name}} = object;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = obj;
          return `<span class='fontStyle'>${name}</span><br/>
                  무선국 수 : ${numberWithCommas(total)}개<br/>`;
        }
        // return undefined일 경우 leaflet 에러남
        return `<span class='fontStyle'>${name}</span><br/>
                무선국 수 : 0개<br/>`;
      },
      getLevelFillColor: ({properties: {pk}}, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const {total} = (metricObject[code] || {total: 1});
        if (total >= 1) {
          const index = Math.floor(PALETTE_YlOrRd_9.length * (total - 1) / metricMax);
          return PALETTE_YlOrRd_9[index];
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_POINT_LAYER_PROPS: {
      // getIconCode: ({frq, frq_hz, cls_code}) => {
      getIconCode: ({cls_code}) => {
        try {
          // return ICON_MAPPING[frq || frq_hz][0];
          return ICON_MAPPING[cls_code][0];
        }catch (e) {
          console.error("not found iconCode for", cls_code);
          return null;
        }
      },
      //////////////////////////////////// 이부분 수정해야함, 커버리지변수값으로 이미지 크기 가져오기
      getIconWidth: (feature, zoom) => {
        let iconWidth = 30;
        //// 비윺값으로 변수 하나 생성
        let iconWidthRateCls = 1;
        let iconWidthRateDis = 1;

        //// 국종가중치 리턴
        clsCoverageList.forEach(function (value,index, array)
        {
          if(value.usgCode == feature.cls_code) {
            iconWidthRateCls = value.usgCoverage;
          }
        })
        //// 지역가중치 리턴
        disCoverageList.forEach(function (value,index, array)
        {
          if(value.usgCode == feature.district_code_lv1) {
            iconWidthRateDis = value.usgCoverage;
          }
        });

        if(zoom <=9) {
          //return 12
          return 12 * iconWidthRateCls * iconWidthRateDis;
        } else if (zoom <= 10) {
          return 15 * iconWidthRateCls * iconWidthRateDis;
        } else if (zoom <= 11) {
          return 18 * iconWidthRateCls * iconWidthRateDis;
        } else if (zoom <= 12) {
          return 21 * iconWidthRateCls * iconWidthRateDis;
        } else if (zoom <= 13) {
          return 24 * iconWidthRateCls * iconWidthRateDis;
        } else if (zoom <= 16) {
          return 30 * iconWidthRateCls * iconWidthRateDis;
        }else if (zoom >= 17) {
          return 34 * iconWidthRateCls * iconWidthRateDis;
        } else {
          iconWidth -= iconWidth * (15 - Math.max(7, zoom)) / 14;
          return Math.min(30, iconWidth);
        }

      }
    },
    INITIAL_WIDGET_STATE: {
      frq_list: ['1'],
      div_code_stats_list: ["00", "01", "02", "04", "05", "06", "07", "08"],
      sta_code_stats_list: ["00", "01", "02"],
      cls_code_stats_list: Object.keys(ICON_MAPPING),
      isClsSearch: true, // 무선국종을 기본 조건으로 세팅합니다.
      field1: "",
      field2: "",
      field3: "",
      field4: "",
      frqField1: 0,
      frqField2: 99999999999,
      frq_gubun_field: ["FRQ", "FRQ1", "FRQ2", "FRQ3", "FRQ4", "FRQ5", "FRQ6"],
      hz_gubun_field: [1, 1000, 1000000, 1000000000],
      field1Gubun: ["sWhere", "sLike"],
      field2Gubun: ["sWhere", "sLike"],
      field3Gubun: ["sWhere", "sLike"],
      field4Gubun: ["sWhere", "sLike"],
    },
  });

  const {
    clickedPointIconObjects,
    setClickedPointIconObjects,
    widgetState,
    currentDistrictCode,
    setCurrentDistrictCode,
    setPointsLayerFilterFunc,
    mapDistrictStats, setMapDistrictStats, isChangedMapDistrictStats,
    clickedPolygonGeojsonObjects,
    setGeojsonExtraParams,
    dataResponseList,
    pointsResponseList,
  } = mapProps;

  /*
  const [statsJsonSearchCodeList, setStatsJsonSearchCodeList] =
    useState(["1"]);
  */

  const {
    frq_list,
    div_code_stats_list,
    sta_code_stats_list,
    cls_code_stats_list,
    //값이 변하는것 넣어놓고,
    field1,
    field2,
    field3,
    field4,
    frqField1,
    frqField2,
    frq_gubun_field,
    hz_gubun_field,
    field1Gubun,
    field2Gubun,
    field3Gubun,
    field4Gubun,
  } = widgetState;
  const [sidoCode, setSidoCode] = useState('');
  const [sidoArea, setSidoArea] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [isNationwide, setIsNationwide] = useState(false);

  // 광역 단위인 경우 클러스터링 보기  / 시군구 단위인 경우 아이콘 보기
  // useEffect(() => {
  //   if(currentDistrictCode && currentDistrictCode.length === 2){
  //     setIsClusteringPoint(true);
  //   } else {
  //     setIsClusteringPoint(false);
  //   }
  // }, [currentDistrictCode]);

  useEffect(() => {
    const {
        frq_list,
        div_code_stats_list,
        sta_code_stats_list,
        cls_code_stats_list,
        //값이 변하는것 넣어놓고,
        field1,
        field2,
        field3,
        field4,
        frqField1,
        frqField2,
        frq_gubun_field,
        hz_gubun_field,
        field1Gubun,
        field2Gubun,
        field3Gubun,
        field4Gubun,
    } = widgetState;

    const metricObject = {};
    if (dataResponseList.length > 0) {

      const firstDataLayer = dataResponseList[0];
      for (let [code, stats] of Object.entries(firstDataLayer)) {
        let total = 0;
        for (let [checkCode, stat] of Object.entries(stats)) {
          let tmpArr = checkCode.split(':');

          let divVal = tmpArr[0]; // 구분
          let staVal = tmpArr[1]; // 상태
          let clsVal = tmpArr[2]; // 국종
          let mtrVal = tmpArr[3]; // 신목적
          let stdVal = tmpArr[4]; // 지정기준
          let useVal = tmpArr[5]; // 지정용도
          let cusVal = tmpArr[6]; // 시설자
          let frqGubunVal = tmpArr[7]; // 대역구분
          let frqVal = tmpArr[8]; // 중심주파수
          //stdVal = JSON.stringify(stdVal);
          let hzVal = 1;

          if(isNaN(hz_gubun_field) == true){
            hzVal = 1;
          } else{
            hzVal = hz_gubun_field;
          }
              // 폴리콘생성부분
              if (div_code_stats_list.includes(divVal)   // 체크박스의 모든 조건을 만족할 때
                && sta_code_stats_list.includes(staVal)
                && cls_code_stats_list.includes(clsVal)
                && mtrVal.includes(field1)
                && stdVal.includes(field2)
                && useVal.includes(field3)
                && cusVal.includes(field4)
                && parseInt(frqVal) >= parseInt(frqField1)*hzVal
                && parseInt(frqVal) <= parseInt(frqField2)*hzVal
                && frq_gubun_field.includes(frqGubunVal)
                ) {
                    // 하드코딩 하였음(개선필요함) !== : 포함, === : 동일
                    if( field1Gubun !== "sWhere" && field2Gubun !== "sWhere" && field3Gubun !== "sWhere" && field4Gubun !== "sWhere"){ // 포함 포함 포함 포함
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                    }
                    else if( field1Gubun !== "sWhere" && field2Gubun !== "sWhere" && field3Gubun !== "sWhere" && field4Gubun === "sWhere"){ // 포함 포함 포함 동일
                      if( cusVal.length == field4.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun !== "sWhere" && field2Gubun !== "sWhere" && field3Gubun === "sWhere" && field4Gubun !== "sWhere"){ // 포함 포함 동일 포함
                      if ( useVal.length == field3.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun !== "sWhere" && field2Gubun !== "sWhere" && field3Gubun === "sWhere" && field4Gubun === "sWhere"){ // 포함 포함 동일 동일
                      if ( useVal.length == field3.length && cusVal.length == field4.length){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun !== "sWhere" && field2Gubun === "sWhere" && field3Gubun !== "sWhere" && field4Gubun !== "sWhere"){ // 포함 동일 포함 포함
                      if( stdVal.length == field2.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun !== "sWhere" && field2Gubun === "sWhere" && field3Gubun !== "sWhere" && field4Gubun === "sWhere"){ // 포함 동일 포함 동일
                      if ( stdVal.length == field2.length && cusVal.length == field4.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun !== "sWhere" && field2Gubun === "sWhere" && field3Gubun === "sWhere" && field4Gubun !== "sWhere"){ // 포함 동일 동일 포함
                      if ( stdVal.length == field2.length && useVal.length == field3.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun !== "sWhere" && field2Gubun === "sWhere" && field3Gubun === "sWhere" && field4Gubun === "sWhere"){ // 포함 동일 동일 동일
                      if( stdVal.length == field2.length && useVal.length == field3.length && cusVal.length == field4.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun === "sWhere" && field2Gubun !== "sWhere" && field3Gubun !== "sWhere" && field4Gubun !== "sWhere"){ // 동일 포함 포함 포함
                      if ( mtrVal.length == field1.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun === "sWhere" && field2Gubun !== "sWhere" && field3Gubun !== "sWhere" && field4Gubun === "sWhere"){ // 동일 포함 포함 동일
                      if ( mtrVal.length == field1.length && cusVal.length == field4.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun === "sWhere" && field2Gubun !== "sWhere" && field3Gubun === "sWhere" && field4Gubun !== "sWhere"){ // 동일 포함 동일 포함
                      if( mtrVal.length == field1.length && useVal.length == field3.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun === "sWhere" && field2Gubun !== "sWhere" && field3Gubun === "sWhere" && field4Gubun === "sWhere"){ // 동일 포함 동일 동일
                      if ( mtrVal.length == field1.length && useVal.length == field3.length && cusVal.length == field4.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun === "sWhere" && field2Gubun === "sWhere" && field3Gubun !== "sWhere" && field4Gubun !== "sWhere"){ // 동일 동일 포함 포함
                      if ( mtrVal.length == field1.length && stdVal.length == field2.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun === "sWhere" && field2Gubun === "sWhere" && field3Gubun !== "sWhere" && field4Gubun === "sWhere"){ // 동일 동일 포함 동일
                      if( mtrVal.length == field1.length && stdVal.length == field2.length && cusVal.length == field4.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun === "sWhere" && field2Gubun === "sWhere" && field3Gubun === "sWhere" && field4Gubun !== "sWhere"){ // 동일 동일 동일 포함
                      if ( mtrVal.length == field1.length && stdVal.length == field2.length && useVal.length == field3.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                    else if( field1Gubun === "sWhere" && field2Gubun === "sWhere" && field3Gubun === "sWhere" && field4Gubun === "sWhere"){ // 동일 동일 동일 동일
                      if ( mtrVal.length == field1.length && stdVal.length == field2.length && useVal.length == field3.length && cusVal.length == field4.length ){
                        const codeVal = firstDataLayer[code][checkCode];
                        total += codeVal;
                      }
                    }
                }
        }
        metricObject[code] = {total};
      }
    }

    setSidoCode((currentDistrictCode || '').length < 2
      ? ''
      : currentDistrictCode.substr(0, 2));

    const metricMax = Math.max(...Object.values(metricObject).map(obj => obj.total));

    const newMapDistrictStats = [metricObject, metricMax];
    if (isChangedMapDistrictStats(newMapDistrictStats)) {
      setMapDistrictStats(newMapDistrictStats);
    }
  }, [dataResponseList, widgetState, currentDistrictCode]);


  useEffect(() => {

    if (!currentDistrictCode) {
      if ( pointsResponseList.length >0){
        window.pointsResponseList = pointsResponseList;
        // eslint-disable-next-line array-callback-return
        const hiddenUid = pointsResponseList[0].map((value) => {
          const {frq, uid} = value;

          if (frq_list.includes(frq)){
            return uid;
          }
        });
      }
      setPointsLayerFilterFunc(() => ({frq}) => {
        return false
      });
    } else {
      // 포인트생성부분
      setPointsLayerFilterFunc(() => ({frq, cls_code, div_code, sta_code, newmtr_code, std_code, use_code, cus_fln, frq_gubun, district_code}) => {
        if (!cls_code_stats_list.includes(cls_code))
          return false;
        if (!div_code_stats_list.includes(div_code))
          return false;
        if (!sta_code_stats_list.includes(sta_code))
          return false;

        // 하드코딩 하였음(개선필요함)
        if( field1Gubun === "sWhere"){ //동일
          if(field1.length == newmtr_code.length){
             newmtr_code = newmtr_code === null ? '' : newmtr_code === ' ' ? '' : newmtr_code;
             if (!newmtr_code.includes(field1))
               return false;
          }
          else{
              return false;
          }
        }
        if( field1Gubun !== "sWhere"){ //포함
          if(field1.length > 2){
            newmtr_code = newmtr_code === null ? '' : newmtr_code === ' ' ? '' : newmtr_code;
            if (!newmtr_code.includes(field1))
              return false;
          }
        }

        if( field2Gubun === "sWhere"){ //동일
          if(field2.length == std_code.length){
            std_code = std_code === null ? '' : std_code === ' ' ? '' : std_code;
            if (!std_code.includes(field2))
               return false;
          }
          else{
              return false;
          }
        }
        if( field2Gubun !== "sWhere"){ //포함
         if(field2.length > 3){
          std_code = std_code === null ? '' : std_code === ' ' ? '' : std_code;
          if (!std_code.includes(field2))
            return false;
          }
        }

        if( field3Gubun === "sWhere"){ //동일
          if(field3.length > 2){
            use_code = use_code === null ? '' : use_code === ' ' ? '' : use_code;
            if (!use_code.includes(field3))
              return false;
          }
        }
        if( field3Gubun !== "sWhere"){ //포함
          if(field3.length > 2){
            use_code = use_code === null ? '' : use_code === ' ' ? '' : use_code;
            if (!use_code.includes(field3))
              return false;
          }
        }

        if( field4Gubun === "sWhere"){ //동일
          if(field4.length > 1){
            cus_fln = cus_fln === null ? '' : cus_fln === ' ' ? '' : cus_fln;
            if (!cus_fln.includes(field4))
              return false;
          }
        }
        if( field4Gubun !== "sWhere"){ //포함
          if(field4.length > 1){
            cus_fln = cus_fln === null ? '' : cus_fln === ' ' ? '' : cus_fln;
            if (!cus_fln.includes(field4))
              return false;
          }
        }

        if(frq_gubun_field.length == 3){
          let gubunArr = frq_gubun_field.split(':');
          let gval = gubunArr[0];
          frq_gubun = frq_gubun === null ? '' : frq_gubun === ' ' ? '' : frq_gubun;
          if (!frq_gubun.includes(gval))
            return false;
        }
        if(frq_gubun_field.length == 4){
          frq_gubun = frq_gubun === null ? '' : frq_gubun === ' ' ? '' : frq_gubun;
          if (!frq_gubun.includes(frq_gubun_field))
            return false;
        }
        if (!district_code)
          return false;

        //필요유무 모르겠음.
        //setPointsLayerFilterFunc(() => ({ cls_code }) => cls_code_stats_list.includes(cls_code));

        return (
          frq_list.includes(frq) &&
          district_code.startsWith(currentDistrictCode)
        );
      });
      ExeJackDraw();
    }
  }, [widgetState, currentDistrictCode, pointsResponseList]);

  useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()].map(colorIndex => {
          const boundary = (metricMax / 9) * (colorIndex + 1);
          const index = Math.floor(PALETTE_YlOrRd_9.length * (boundary - 1) / metricMax);
          const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
          return [colorRgb, boundary];
        }).reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    setGeojsonExtraParams(prev => ({
      ...prev,
      currentDistrictCode,
    }));
    if ((currentDistrictCode||'').length <= 2) {
      setIsVisible(false);
    }
  }, [currentDistrictCode]);



  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      setCurrentDistrictCode(pk);
      setSidoCode(pk.substr(0, 2));
      setSidoArea(name);
      if ((pk||'').length <= 2){
        setIsVisible(false);
      }
    }
  }, [clickedPolygonGeojsonObjects]);

  const onClickedPointInWidgetTable = useCallback((feature) => {
    const {latitude, longitude, lat, lon} = feature;
    const newLatitude = positionToDegress(latitude || lat);
    const newLongitude = positionToDegress(longitude || lon);
    const newFeature = {...feature, position: [newLongitude, newLatitude]};
    setClickedPointIconObjects([newFeature]);
  }, [setClickedPointIconObjects]);

  const {isClsSearch} = widgetState;

  useEffect(() => {
    coverageListAxios();
  }, []);


  const coverageListAxios = () => {
    const url_district = getApiHost() + '/gisToolView/jointUseCoverageList.do';
    const formData = new FormData();
    formData.append('menuNo', '300631');

    // 이용효율 커버리지 테이블 리스트
    Axios.all([
        Axios.post(url_district, formData)
      ]
    ).then(Axios.spread((districtResponse, frqResponse) => {
      // 커버리지 테이블 가져오기
      let coverageList = districtResponse['data']['rows'];

      clsCoverageList = coverageList.filter(tmpRow => tmpRow.usgType == 'common');
      disCoverageList = coverageList.filter(tmpRow => tmpRow.usgType == 'location');

    })).catch((e1) => {
      console.error(e1);
      //setError(e1);
    }).finally(() => {
      //setIsLoading(false);
      //setVisible(true);
    });
  }


  //// 포인트 폴리곤 데이터
  let mapMatrixSil = [];

  // 색상설정
  let colorArr = [
    "#FF0000",
    "#FFB630",
    '#FFF809',
    '#41DF62',
    '#3057FF',
    '#CB32C7',
    '#FFE800',
    '#212F3D',
    '#7D3C98',
    '#0EDEEC',
    '#00C9FF',
    '#F08080',
    '#21618C',
    '#A04000',
    '#EC0E94',
  ];

  let canvasMatrix = [
    [
      {"canvasX": 0, "canvasY": 0, "rColor": 99, "gColor": 99, "bColor" : 99, "alphaColor" : 99, "jackPot" : 99},
      {"canvasX": 0, "canvasY": 1, "rColor": 20, "gColor": 20, "bColor" : 1, "alphaColor" : 1, "jackPot" : 0},
      {"canvasX": 0, "canvasY": 2, "rColor": 20, "gColor": 20, "bColor" : 1, "alphaColor" : 1, "jackPot" : 0},
    ],
    [
      {"canvasX": 1, "canvasY": 0, "rColor": 20, "gColor": 20, "bColor" : 1, "alphaColor" : 1, "jackPot" : 0},
      {"canvasX": 1, "canvasY": 1, "rColor": 20, "gColor": 20, "bColor" : 1, "alphaColor" : 1, "jackPot" : 0},
      {"canvasX": 1, "canvasY": 2, "rColor": 20, "gColor": 20, "bColor" : 1, "alphaColor" : 1, "jackPot" : 0},
    ],
    [
      {"canvasX": 2, "canvasY": 0, "rColor": 20, "gColor": 20, "bColor" : 1, "alphaColor" : 1, "jackPot" : 0},
      {"canvasX": 2, "canvasY": 1, "rColor": 20, "gColor": 20, "bColor" : 1, "alphaColor" : 1, "jackPot" : 0},
      {"canvasX": 2, "canvasY": 2, "rColor": 20, "gColor": 20, "bColor" : 1, "alphaColor" : 1, "jackPot" : 0},
    ]
  ];


  //function DrawSudong(canvasMatrix, mapMatrixSil) {
  function SelectedPointList() {

    let currPointsResponseList = pointsResponseList[0];
    let currPointsResponseListLength = currPointsResponseList.length;

    let tmpArr2 = [];

    for(var h=0; h<currPointsResponseListLength; h++) {
    //for(var h=0; h<4; h++) {

      
      // 시군구 값이 있을 경우 해당 시군구만 거르기
      if( currentDistrictCode != undefined &&  currentDistrictCode.length > 2) {
        if ( !currentDistrictCode.includes(currPointsResponseList[h].district_code) )
          continue;
      }
      
      // 선택된 포인트 리스트
      if (!widgetState.cls_code_stats_list.includes(currPointsResponseList[h].cls_code))
        continue;
      if (!widgetState.div_code_stats_list.includes(currPointsResponseList[h].div_code))
        continue;
      if (!widgetState.sta_code_stats_list.includes(currPointsResponseList[h].sta_code))
        continue;

      //// 하드코딩 하였음(개선필요함)
      if( widgetState.field1Gubun === "sWhere"){ //동일
        if(widgetState.field1.length == currPointsResponseList[h].newmtr_code.length){
            currPointsResponseList[h].newmtr_code = currPointsResponseList[h].newmtr_code === null ? '' : currPointsResponseList[h].newmtr_code === ' ' ? '' : currPointsResponseList[h].newmtr_code;
            if (!currPointsResponseList[h].newmtr_code.includes(widgetState.field1))
              continue;
        }
        else{
            continue;
        }
      }
      if( widgetState.field1Gubun !== "sWhere"){ //포함
        if(widgetState.field1.length > 2){
          currPointsResponseList[h].newmtr_code = currPointsResponseList[h].newmtr_code === null ? '' : currPointsResponseList[h].newmtr_code === ' ' ? '' : currPointsResponseList[h].newmtr_code;
          if (!currPointsResponseList[h].newmtr_code.includes(widgetState.field1))
            continue;
        }
      }

      if( widgetState.field2Gubun === "sWhere"){ //동일
        if(widgetState.field2.length == currPointsResponseList[h].std_code.length){
          currPointsResponseList[h].std_code = currPointsResponseList[h].std_code === null ? '' : currPointsResponseList[h].std_code === ' ' ? '' : currPointsResponseList[h].std_code;
          if (!currPointsResponseList[h].std_code.includes(widgetState.field2))
              continue;
        }
        else{
            continue;
        }
      }
      if( widgetState.field2Gubun !== "sWhere"){ //포함
        if(widgetState.field2.length > 3){
        currPointsResponseList[h].std_code = currPointsResponseList[h].std_code === null ? '' : currPointsResponseList[h].std_code === ' ' ? '' : currPointsResponseList[h].std_code;
        if (!currPointsResponseList[h].std_code.includes(widgetState.field2))
          continue;
        }
      }

      if( widgetState.field3Gubun === "sWhere"){ //동일
        if(widgetState.field3.length > 2){
          currPointsResponseList[h].use_code = currPointsResponseList[h].use_code === null ? '' : currPointsResponseList[h].use_code === ' ' ? '' : currPointsResponseList[h].use_code;
          if (!currPointsResponseList[h].use_code.includes(widgetState.field3))
            continue;
        }
      }
      if( widgetState.field3Gubun !== "sWhere"){ //포함
        if(widgetState.field3.length > 2){
          currPointsResponseList[h].use_code = currPointsResponseList[h].use_code === null ? '' : currPointsResponseList[h].use_code === ' ' ? '' : currPointsResponseList[h].use_code;
          if (!currPointsResponseList[h].use_code.includes(widgetState.field3))
            continue;
        }
      }

      if( widgetState.field4Gubun === "sWhere"){ //동일
        if(widgetState.field4.length > 1){
          currPointsResponseList[h].cus_fln = currPointsResponseList[h].cus_fln === null ? '' : currPointsResponseList[h].cus_fln === ' ' ? '' : currPointsResponseList[h].cus_fln;
          if (!currPointsResponseList[h].cus_fln.includes(widgetState.field4))
            continue;
        }
      }
      if( widgetState.field4Gubun !== "sWhere"){ //포함
        if(widgetState.field4.length > 1){
          currPointsResponseList[h].cus_fln = currPointsResponseList[h].cus_fln === null ? '' : currPointsResponseList[h].cus_fln === ' ' ? '' : currPointsResponseList[h].cus_fln;
          if (!currPointsResponseList[h].cus_fln.includes(widgetState.field4))
            continue;
        }
      }

      if(widgetState.frq_gubun_field.length == 3){
        let gubunArr = currPointsResponseList[h].widgetState.frq_gubun_field.split(':');
        let gval = gubunArr[0];
        currPointsResponseList[h].frq_gubun = currPointsResponseList[h].frq_gubun === null ? '' : currPointsResponseList[h].frq_gubun === ' ' ? '' : currPointsResponseList[h].frq_gubun;
        if (!currPointsResponseList[h].frq_gubun.includes(gval))
          continue;
      }
      if(widgetState.frq_gubun_field.length == 4){
        currPointsResponseList[h].frq_gubun = currPointsResponseList[h].frq_gubun === null ? '' : currPointsResponseList[h].frq_gubun === ' ' ? '' : currPointsResponseList[h].frq_gubun;
        if (!currPointsResponseList[h].frq_gubun.includes(widgetState.frq_gubun_field))
          continue;
      }
      if (!currPointsResponseList[h].district_code)
        continue;



      tmpArr2.push(currPointsResponseList[h]);

    } //for

    return tmpArr2;
  }




  //// 4개 점으로 캔버스배열 생성하기
  function CanvasMatrixCreate(minLon=0, maxLon=10, minLat=0, maxLat=10, divideCnt=10) {

    //// 대한민국 지도 위경도 최저점 124.6097088, 128.9711903, 33.11371207, 37.42829748
    //// 캔버스크기 는 * 10칸으로 사용
    let canvasXAxisSize = divideCnt * 10;

    const variationX = 1;
    const variationY = 1;
    let arr = [];

    //// Y축 로우 생성
    for(var i=0; i<canvasXAxisSize; i++) {
      arr[i] = [];
      let tmpObj = {"canvasX": 0, "canvasY": 0, "rColor": 0, "gColor": 0, "bColor" : 0, "alphaColor" : 0, "jackPot" : 0};

      //y증가
      tmpObj.canvasY = minLat + (variationY * i);
      //고정
      tmpObj.canvasX = minLon;

      //// X축 열 생성
      for(var j=0; j<canvasXAxisSize; j++) {

        let tmpObj = {"canvasX": 0, "canvasY": 0, "rColor": 0, "gColor": 0, "bColor" : 0, "alphaColor" : 0, "jackPot" : 0};

        //x증가
        tmpObj.canvasX = minLon + (variationX * j);
        //고정
        tmpObj.canvasY = minLat + (variationY * i);
        tmpObj.rColor = 0;
        tmpObj.gColor = 0;
        tmpObj.bColor = 0;
        tmpObj.alphaColor = 0;
        tmpObj.jackPot = 0;

        arr[i].push(tmpObj);
      }
    }
    return arr;
  }

  //// 나눌값 설정
  let divideCnt = 20;
  //// 캔버스크기 는 * 10칸으로 사용
  let canvasXAxisSize = divideCnt * 10;
  // 캔버스생성
  canvasMatrix = CanvasMatrixCreate(0,divideCnt,0,divideCnt,divideCnt);


  //// 이용효율 직접그리기
  function DrawSudong(canvasMatrix, mapMatrixSil) {

    mapMatrixSil = SelectedPointList();

    if(mapMatrixSil.length < 1) {
      //alert("포인트 데이터가 로드 되지 않았습니다!!");
      setPointPercent("0%");
      return;
    }
    clearCanvas();

    var canvas2 = document.getElementById("canvas2");
    var ctx = canvas2.getContext('2d');

    //// X축 라스트 인덱스 구하기
    let canvasMatrixLastIndexX = canvasMatrix[0].length-1;
    //// Y축 라스트 인덱스 구하기
    let canvasMatrixLastIndexY = canvasMatrix.length-1;

    if (canvas2.getContext) {
      var i = 0;
      var j = 0;
      var x = 25 + j * 50; // x coordinate
      var y = 25 + i * 50; // y coordinate
      var radius = 0.5; // Arc radius
      //// 국종별, 지역별 커버리지
      var clsCoverage = 1;
      var disCoverage = 1;

      var startAngle = 0; // Starting point on circle
      //var endAngle = Math.PI + (Math.PI * j) / 2; // End point on circle
      var endAngle = Math.PI * 2;
      var anticlockwise = i % 2 == 0 ? false : true; // clockwise or anticlockwise

      //X축 평행이동값 -124, Y축 평행이동값 -33
      let pointTmpX = 0.00;
      let pointTmpY = 0.00;

      //포문설정
      for(i=0; i<mapMatrixSil.length; i++) {
      //for(i=0; i<10; i++) {

        //// 반지름 초기화
        radius = 0.5;

        pointTmpX = mapMatrixSil[i].position[0];
        pointTmpY = mapMatrixSil[i].position[1];

        //// 시도범위 벗어나는지 확인
        // 전국
        //let sidoCode = '';
        //let currentDistrictCode = '';

        // 서울시
        //let sidoCode = '11';
        //let currentDistrictCode = '11';
        
        //무슨구
        //let sidoCode = '11';
        //let currentDistrictCode = '11110';
        
        let localMinX = SIDO_AREA[99][2];
        let localMaxX = SIDO_AREA[99][3];
        let localMinY = SIDO_AREA[99][4];
        let localMaxY = SIDO_AREA[99][5];

        //// 전국
        if(sidoCode.length < 1) {
          //sidoCode = '99';
        }
        //// 시군구
        else if( currentDistrictCode != undefined &&  currentDistrictCode.length > 2) {
          localMinX = SIDO_AREA[sidoCode][2];
          localMaxX = SIDO_AREA[sidoCode][3];
          localMinY = SIDO_AREA[sidoCode][4];
          localMaxY = SIDO_AREA[sidoCode][5];
        }
        //// 시도
        else {
          localMinX = SIDO_AREA[currentDistrictCode][2];
          localMaxX = SIDO_AREA[currentDistrictCode][3];
          localMinY = SIDO_AREA[currentDistrictCode][4];
          localMaxY = SIDO_AREA[currentDistrictCode][5];
        }

        
        //// X좌표가 시도범위를 벗어나면 건너뛰기
        if( pointTmpX <= localMinX || pointTmpX >= localMaxX ) {
          //console.log("포인트 원본 좌표" + i + " 번째 : " + pointTmpX + ", " + pointTmpY);
          //console.log("범위밖 포인트 X축" + i + "번째, 최저X, 최대X", pointTmpX, localMinX, localMaxX);
          continue;
        }
        if( pointTmpY <= localMinY || pointTmpY >= localMaxY ) {
          //console.log("포인트 원본 좌표" + i + " 번째 : " + pointTmpX + ", " + pointTmpY);
          //console.log("범위밖 포인트 Y축" + i + "번째, 최저Y, 최대Y", pointTmpY, localMinY, localMaxY);
          continue;
        }

        //// 위경도 변환
        //// 지도 위경도 최저점 124.6097088, 128.9711903, 33.11371207, 37.42829748
        pointTmpX = ((pointTmpX - 124) * divideCnt).toFixed(0);
        // pointTmpY = ((pointTmpY - 33) * divideCnt).toFixed(0); // 단지 보기 좋게 위로 이동
        pointTmpY = ((pointTmpY - 31) * divideCnt).toFixed(0);
        // 1사분면, 4사분면 변환
        pointTmpY = (divideCnt * 10)-pointTmpY;

        //console.log("포인트 변환 식 : " + "((pointTmpX - 124) * divideCnt).toFixed(0), (divideCnt * 10)-((pointTmpY - 33) * divideCnt).toFixed(0)");
        //console.log("포인트 변환 좌표" + i + " 번째 : " + pointTmpX + ", " + pointTmpY);

        //// 국종가중치 리턴
        clsCoverageList.forEach(function (value,index, array)
        {
          if(value.usgCode == mapMatrixSil[i].cls_code) {
            clsCoverage = value.usgCoverage;
          }
        });
        //// 지역가중치 리턴
        disCoverageList.forEach(function (value,index, array)
        {
          if(value.usgCode == mapMatrixSil[i].district_code_lv1) {
            disCoverage = value.usgCoverage;
          }
        })

        //// 최종 반지름
        radius = 0.5 * clsCoverage * disCoverage;
        
        /*
        if(radius < 1) {
          //console.log("반지름이 1픽셀보다 작을경우 radius : ", radius);
          //console.log("반지름이 1픽셀보다 작은 국종 cls_code : ", mapMatrixSil[i].cls_code);
          //console.log("반지름이 1픽셀보다 작은 지역 district_code_lv1 : ", mapMatrixSil[i].district_code_lv1);
          radius = 1;
        }
        */

        // console.log("sidoCode : ", sidoCode);
        // console.log("clsCoverage : ", clsCoverage, mapMatrixSil[i].cls_code);
        // console.log("disCoverage : ", disCoverage, mapMatrixSil[i].district_code_lv1);
        // console.log("radius : ", radius);


        //// 지역별 커버리지 변수(반지름), clsCoverage * disCoverage, 이부분 코드 짜야함
        //// 색칠할것 넣기
        ctx.beginPath();
        //ctx.fillStyle = colorArr[i%colorArr.length];
        if(mapMatrixSil[i].district_code_lv1 == 11) {   //서울
          ctx.fillStyle = "#C4C0C0"; // 밝은회색
        }
        if(mapMatrixSil[i].district_code_lv1 == 26) {   // 부산
          ctx.fillStyle = "#FF53B1";  // 핑크
        }
        if(mapMatrixSil[i].district_code_lv1 == 27) {   // 대구
          ctx.fillStyle = "##01F2FA";  // 청록
        }
        if(mapMatrixSil[i].district_code_lv1 == 28) {   // 인천
          ctx.fillStyle = "#0000FF";  // 블루
        }
        if(mapMatrixSil[i].district_code_lv1 == 29) {   // 광주
          ctx.fillStyle = "#CA6F1E";  // 빨강
        }
        if(mapMatrixSil[i].district_code_lv1 == 30) {   // 대전
          ctx.fillStyle = "#770088";  //
        }
        if(mapMatrixSil[i].district_code_lv1 == 31) {   // 울산
          ctx.fillStyle = "#012340";  //
        }
        if(mapMatrixSil[i].district_code_lv1 == 36) {   // 세종
          ctx.fillStyle = "#B6B6B6";  // 회색
        }
        if(mapMatrixSil[i].district_code_lv1 == 41) {   // 경기
          ctx.fillStyle = "#FF0000";  // 빨강
        }
        if(mapMatrixSil[i].district_code_lv1 == 42) {   // 강원도
          ctx.fillStyle = "#7D3C98"; // 보라
        }
        if(mapMatrixSil[i].district_code_lv1 == 43) {   // 충청북도
          ctx.fillStyle = "#373737"; // 진한회색
        }
        if(mapMatrixSil[i].district_code_lv1 == 44) {   // 충청남도
          ctx.fillStyle = "#FA7201"; // 주황
        }
        if(mapMatrixSil[i].district_code_lv1 == 45) {   // 전라북도
          ctx.fillStyle = "#60D1F2"; // 하늘
        }
        if(mapMatrixSil[i].district_code_lv1 == 46) {   // 전라남도
          ctx.fillStyle = "#B753F9";  // 연보라
        }
        if(mapMatrixSil[i].district_code_lv1 == 47) {   //경상북도
          ctx.fillStyle = "#00FF00";  // 그린
        }
        if(mapMatrixSil[i].district_code_lv1 == 48) {   //경상남도
          ctx.fillStyle = "#FFE800";  // 노랑
        }
        if(mapMatrixSil[i].district_code_lv1 == 50) {   // 제주도
          ctx.fillStyle = "#F0009C";  //핫핑크
        }



        ctx.arc(pointTmpX, pointTmpY, radius, 0, (Math.PI * 2), true);
        ctx.fill();


        //// 원 커버리지만큼 좌표 가져오기
        // 마지막에 한꺼번에 하고 싶지만 canvas fill()이 달라지기 때문에..., 방법은 먼저 정렬을 하던지 해야함
        //// getImageData( (중심점X-반지름, 중심점Y-반지름, 반지름*2, 반지름*2) )

        //// 좌상, 우하 좌표 찾기
        let fixelStartX = parseInt(pointTmpX - radius);
        let fixelStartY = parseInt(pointTmpY - radius);

        // 범위가 벗어낫을 경우 예외처리
        if( fixelStartX < 0 ) { fixelStartX = 0; }
        if( fixelStartX > canvasXAxisSize ) { fixelStartX = canvasXAxisSize-1; }
        if( fixelStartY < 0 ) { fixelStartY = 0; }
        if( fixelStartY > canvasXAxisSize ) { fixelStartY = canvasXAxisSize-1; }

        let fixelWidth = radius * 2;
        let fixelHight = radius * 2;

        // 범위가 벗어낫을 경우 예외처리
        if( fixelWidth < 0 ) { fixelWidth = 0; }
        if( fixelWidth > canvasXAxisSize ) { fixelWidth = canvasXAxisSize; }
        if( fixelHight < 0 ) { fixelHight = 0; }
        if( fixelHight > canvasXAxisSize ) { fixelHight = canvasXAxisSize; }

        let fixelData = ctx.getImageData(fixelStartX, fixelStartY, fixelWidth, fixelHight).data;

        // 칠해져있는 배열 가져오기(4개의색상이 다 제공되서 배열/4 해야함)
        let tmpArr = [
        ];

        let tmpArrRow = {
          rColor : 0,
          gColor : 0,
          bColor : 0,
          alphaColor : 0,
        };

        for(var k=0; k < fixelData.length; k++) {
          // 1개의 픽셀마다 4개의 색상값이 있음 (RGB알파)
          if(k%4 == 0) {
            tmpArrRow = {
              rColor : 99,
              gColor : 99,
              bColor : 99,
              alphaColor : 99,
            };
            tmpArrRow.rColor = fixelData[k];
          }
          else if(k%4 == 1) {
            tmpArrRow.gColor = fixelData[k];
          }
          else if(k%4 == 2) {
            tmpArrRow.bColor = fixelData[k];
          }
          else if(k%4 == 3) {
            tmpArrRow.alphaColor = fixelData[k];
            //// 4개의 색상 세트가 완료 되었을 경우 어레이에 푸쉬한다.
            tmpArr.push(tmpArrRow);
          }
        } // for


        //// 원커버리지, 좌상, 우하 데이터 부터 걸치는 부분 찾기
        // ctx.getImageData() 행렬 모양 때문에 n*n 행렬 다시 가공
        var tmpIndexX = fixelStartX;
        var tmpIndexY = fixelStartY;

        let tmpArrIndex = 0;

        for(var m=0; m<parseInt(tmpArr.length/fixelHight); m++) {
          for(var n=0; n<parseInt(tmpArr.length/fixelWidth); n++) {

            ////////범위밖이면 건너뛰기
            if( 0 <= tmpIndexX && canvasMatrixLastIndexX >= tmpIndexX && 0 <= tmpIndexY && canvasMatrixLastIndexY >= tmpIndexY ) {
              //// 캔버스행렬에 집어넣기
              canvasMatrix[tmpIndexY][tmpIndexX].rColor = tmpArr[tmpArrIndex].rColor;
              canvasMatrix[tmpIndexY][tmpIndexX].gColor = tmpArr[tmpArrIndex].gColor;
              canvasMatrix[tmpIndexY][tmpIndexX].bColor = tmpArr[tmpArrIndex].bColor;
              canvasMatrix[tmpIndexY][tmpIndexX].alphaColor = tmpArr[tmpArrIndex].alphaColor;

              //// 색이 칠해져있으면 색칠여부 1 값으로 주기
              if( (canvasMatrix[tmpIndexY][tmpIndexX].rColor + canvasMatrix[tmpIndexY][tmpIndexX].gColor + canvasMatrix[tmpIndexY][tmpIndexX].bColor) > 0 )
              {
                canvasMatrix[tmpIndexY][tmpIndexX].jackPot = 1;
                //console.log("범위안 칠함: " + tmpIndexX + ", " + tmpIndexY);
              }
              else {
                canvasMatrix[tmpIndexY][tmpIndexX].jackPot = 0;
                //console.log("범위안 안칠함: " + tmpIndexX + ", " + tmpIndexY);
              }

            } // if 범위안
            // 범위밖에 있을경우
            else {
              //console.log("범위밖 : " + tmpIndexX + ", " + tmpIndexY);
              continue;
            }
            tmpIndexX++;
            tmpArrIndex++;
          }
          tmpIndexX = fixelStartX;
          tmpIndexY++;
        }

      } // for

      let jackPotCnt = JcakPotCounting(canvasMatrix);
      //console.log( "칠해진 픽셀 수 : ", jackPotCnt );
      //console.log( "캔버스 크기 : ", canvasXAxisSize * canvasXAxisSize );
      //console.log( "캔버스크기대비 : ", JackPotCalcByCanvas(jackPotCnt, canvasXAxisSize) );    
      //console.log( "이용효율 : ",  JackPotCalc(jackPotCnt, canvasXAxisSize) );
      //JackPotInfo("jackPotRate", "99");

      JackPotCalc(jackPotCnt, canvasXAxisSize);

    } // if canvas2.getContext
  } //DrawSudong


  //// 지도색칠된것 숫자세기, 비율계산을 위한
  function JcakPotCounting(mapMatrix) {
    let jackPotCnt = 0;
    let jcakPotRate = mapMatrix
                          .forEach(
                            mapMatrixRow => {
                              const tmpCnt = mapMatrixRow.filter(mapMatrixTmp => mapMatrixTmp.jackPot == 1).length;
                              const tmpRow = mapMatrixRow.filter(mapMatrixTmp => mapMatrixTmp.jackPot == 1);
                              jackPotCnt += tmpCnt;
                            }
                          );
    return jackPotCnt;
  }

  let [pointPercent, setPointPercent] = useState(0);

  //// 미이용률 계산
  // 이용효율 = ( 1픽셀당 면적 * 칠해진 픽셀 수 / 국토부 면적 )
  function JackPotCalc(jackPotCnt) {
    
    //let perFixelArea = 6.25;
    let perFixelArea = 4;
    let sidoArea = 100401;

    //// 전국이었을경우
    if(sidoCode.length < 1) {
      sidoArea = SIDO_AREA[99][1];
    }
    else if( currentDistrictCode != undefined &&  currentDistrictCode.length > 2) {
      sidoArea = SIDO_AREA[currentDistrictCode][1];
    }
    else {
      sidoArea = SIDO_AREA[sidoCode][1];
    }
    
    let usePercent = (perFixelArea * jackPotCnt) / sidoArea;
    usePercent = (usePercent * 100).toFixed(2) + "%";
    setPointPercent(usePercent);
    
    // console.log( "이용효율 = ( 1픽셀당 면적 * 칠해진 픽셀 수 / 국토부 면적 ) : " );
    // console.log( "이용효율 = perFixelArea" + " * " + "jackPotCnt" + " / " + "sidoArea" );
    // console.log( "이용효율 = 퍼센트 : " + perFixelArea + " * " + jackPotCnt + " / " + sidoArea );
    // console.log( "이용효율 = 퍼센트 : ", usePercent );

    return usePercent;
  }

  //// 캔버스 크기대비 계산
  // 이용효율 = ( 칠해진 픽셀 수 / 캔버스크기 )
  function JackPotCalcByCanvas(jackPotCnt, canvasXAxisSize) {
    let jackPotPercent = (100 * jackPotCnt / (canvasXAxisSize * canvasXAxisSize)).toFixed(2) + "%";
    // console.log( "캔버스 크기대비 " + jackPotPercent + "% 퍼센트");
    return jackPotPercent;
  }

  //// 화면에 개수 디스플레이
  // (칠해진 픽셀 수 / 전체 픽셀 수)
  function JackPotInfo(displayelem, displayText) {
    let displayelement = document.getElementById(displayelem);
    //displayelem.text = displayText;
    displayelement.innerHTML = displayText;
  }

  //// 이용효율 수동그리기 함수 호출
  function ExeJackDraw() {
    if(pointsResponseList.length < 1) {
      alert("포인트 데이터가 로드 되지 않았습니다.");
      setPointPercent("0%");
      return;
    }
    DrawSudong(canvasMatrix, pointsResponseList[0]);
  }

  function clearCanvas() {
    var canvas2 = document.getElementById('canvas2');
    var ctx = canvas2.getContext('2d');
    // 픽셀 정리
    ctx.clearRect(0, 0, canvas2.width, canvas2.height);
    // 컨텍스트 리셋
    ctx.beginPath();
  }





  const tempStyle={
    border: "1px solid blue",
  }
  const tempStyle2={
    border: "1px solid red",
  }


  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isHideGeolocated={true}>
        <WidgetContainer2>
          <div>
            {/* <div onClick={SelectedPointList}>변환함수테스트</div>
            <div onClick={ExeJackDraw}>드로우테스트</div> */}
            {/* {"시도 ? : " + sidoCode} */}
            {/* {"시군구 ? : " + currentDistrictCode} */}
            {/* {"주파수구분? : " + frq_gubun_field} */}
            {/* <button onClick={coverageListAxios}>ajax테스트버튼</button> */}
            <WidgetDistrictSelect isShowDistrictLayerFromGeoserver={true} />
            <WidgetSelectBand/>
            <Seperator/>
            <WidgetFrq2 options={CLS_CODE_OPTIONS} iconCodeByCls={ICON_CODE_BY_CLS_CODE}/>
          </div>
        </WidgetContainer2>
        <WidgetContainer3>
          <div>
            <WidgetCls1 fetchUrl={getApiUrl({type: "type3"})}/>
          </div>
        </WidgetContainer3>


        { <RMateChartJointTableTown
          frqList={frq_list}
          divList={div_code_stats_list}
          staList={sta_code_stats_list}
          clsList={cls_code_stats_list}
          newmtrList={field1}
          stdList={field2}
          useList={field3}
          cusList={field4}
          frqGubunList={frq_gubun_field}
          sidoCode={sidoCode}
          currentDistrictCode={currentDistrictCode}
          iconMapping={ICON_MAPPING}
          disable={widgetState.frq_list.length === 0}
          isVisible={isVisible}
          ExeJackDraw={ExeJackDraw}
          divideCnt={divideCnt}
          canvasXAxisSize={canvasXAxisSize}
          sidoArea={sidoArea}
          pointPercent={pointPercent}
        /> }


        <WidgetTableClicked
          fetchUrl={getApiUrl({type: "type2"})}
          getTitle={objects => `${objects.length}개의 무선국 데이터`}
          objects={clickedPointIconObjects}
          getRow={({uid, frq_hz, cus_fln, rds_new_adr}) =>
            <table>
              <tbody>
              <tr>
                <th>허가번호</th>
                <td>{formatUid(uid)}</td>
              </tr>
              <tr>
                <th>주파수(MHz)</th>
                <td>{frq_hz}</td>
              </tr>
              <tr>
                <th>시설자 명</th>
                <td>{cus_fln}</td>
              </tr>
              <tr>
                <th>설(상)치 장소</th>
                <td>{rds_new_adr}</td>
              </tr>
              </tbody>
            </table>
          }
        />

        <WidgetTable
          disabled={widgetState.frq_list.length === 0 || isNationwide}
          fetchUrl={getApiUrl({type: "type1"})}
          getTitle={(objects) => `${objects.length}개의 무선국 데이터`}
          columns={[
            {title: '순번', dataIndex: 'rnum', key: 'rnum', width: 75, fixed: 'left', align: 'center', sorter: makeTableSorterFn('rnum')},
            {
              title: '허가번호', dataIndex: 'uid', key: 'uid', width: 180, fixed: 'left',
              render: (uid, feature) => WidgetUidWithShortcut({feature, onClick: onClickedPointInWidgetTable}),
              sorter: makeTableSorterFn('uid')
            },
            {title: '무선국 호출명', dataIndex: 'rds_cll_nm', key: 'rds_cll_nm', sorter: makeTableSorterFn('rds_cll_nm')},
            {title: '시설자 명', dataIndex: 'cus_fln', key: 'cus_fln', sorter: makeTableSorterFn('cus_fln')},
            {title: '전파형식코드', dataIndex: 'emdg_cd', key: 'emdg_cd', sorter: makeTableSorterFn('emdg_cd')},
            {title: '주파수(MHz)', dataIndex: 'frq_hz', key: 'frq_hz', sorter: makeTableSorterFn('frq_hz')
              , render: value => AlignRightText({text: value, numberComma: true})
            },
            {title: '신주소 설치장소', dataIndex: 'rds_new_adr', key: 'rds_new_adr', sorter: makeTableSorterFn('rds_new_adr')},
            {title: '위도', dataIndex: 'lat', key: 'lat'},
            {title: '경도', dataIndex: 'lon', key: 'lon'},
          ]}
        />

          <div style={tempStyle2}>색이 칠해진 면적은? <br /><span id="jackPotRate"></span></div>
          {/* <canvas id="canvas2" width={canvasXAxisSize} height={canvasXAxisSize} style={tempStyle}></canvas> */}

        <WidgetLegend fillColorLegend={fillColorLegend}  titleColorLegend={'무선국 수'}  unitColorLegend={'개'}/>
      </MapBase>
      <WidgetToolbar/>
    </MapPropsProvider>
  );
};


export default MapJointuseUtil;